import { Decoration } from '@atlaskit/editor-prosemirror/view';
var hideCursorWidgetStyles = "\n\tposition: absolute;\n\tpointer-events: none;\n\twidth: 0;\n\theight: 0;\n";
var createHideCursorWidget = function createHideCursorWidget() {
  var span = document.createElement('span');
  span.className = 'ProseMirror-hide-cursor';
  span.setAttribute('style', hideCursorWidgetStyles);
  return span;
};
export var createHideCursorDecoration = function createHideCursorDecoration() {
  return Decoration.widget(0, createHideCursorWidget, {
    key: 'hide-cursor-decoration',
    side: -1
  });
};